import { put, call } from "redux-saga/effects";
import { push } from 'react-router-redux';
import Swal from "sweetalert2";
import {
    getEntiteSuccess, getEntiteFail,
    getAllEntitesSuccess, getAllEntitesFail,
    getActiveEntitesSuccess, getActiveEntitesFail,
    getEntitesByCategorySuccess, getEntitesByCategoryFail,
    createEntiteSuccess, createEntiteFail,
    updateEntiteSuccess, updateEntiteFail,
    deleteEntiteSuccess, deleteEntiteFail,
    setEntiteLoading, getOrganigrammeSuccess, getOrganigrammeFail, DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS,
    DOWNLOAD_ENTITIES_TEMPLATE_FAIL, EXPORT_ENTITIES_SUCCESS, EXPORT_ENTITIES_FAIL, IMPORT_ENTITIES_EXCEL_FAIL,
    IMPORT_ENTITIES_EXCEL_SUCCESS, getAllEntitesRequest
} from "../actions/entitesActions";
import {
    API_BASE_URL,
    getRequest,
    putRequest,
    deleteRequest, postRequest, getBlobRequest
} from "../../../api";
import { getSessionItem } from "../../utils/tokenStorage";
import {downloadBlob} from "./formationsSaga";

export function* importEntitiesExcelSaga(action) {
    const token = sessionStorage.getItem("token");
    const uid   = sessionStorage.getItem("uid");
    const { file, dryRun, action: act } = action.payload;

    try {
        const fd = new FormData();
        fd.append("file", file);

        const url = `${API_BASE_URL}/api/entities/import-excel?dryRun=${dryRun}&action=${act}`;
        const res = yield call(postRequest, { url, data: fd, token, extraHeaders: { uid } });

        yield put({ type: IMPORT_ENTITIES_EXCEL_SUCCESS, payload: res.data });

        if (!dryRun) {
            Swal.fire({ icon: "success", title: "Import terminé",
                text: `${res.data.createdCount} traitée(s), ${res.data.skippedCount} ignorée(s)` });
            yield put(getAllEntitesRequest());
        } else {
            Swal.fire({ icon: "info", title: "Prévisualisation",
                text: `${res.data.createdCount} valide(s), ${res.data.skippedCount} erreur(s)` });
        }
    } catch (e) {
        yield put({ type: IMPORT_ENTITIES_EXCEL_FAIL, payload: e.response?.data || e.message });
        Swal.fire({ icon: "error", title: "Erreur import", text: "Import Excel échoué" });
    }
}

export function* exportEntitiesExcelSaga() {
    // La session peut être persistée dans localStorage lorsque « Se souvenir de moi » est activé.
    // getSessionItem couvre les deux stockages et garantit que l'API reçoit toujours le uid requis.
    const token = getSessionItem("token");
    const uid = getSessionItem("uid");
    try {
        if (!uid) {
            throw new Error("Session utilisateur introuvable");
        }

        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/entities/export-excel`,
            token: `Bearer ${token}`,
            extraHeaders: { uid },
        });
        downloadBlob(new Blob([res.data]), "export_entites.xlsx");
        yield put({ type: EXPORT_ENTITIES_SUCCESS });
    } catch (e) {
        yield put({ type: EXPORT_ENTITIES_FAIL });
        Swal.fire({ icon: "error", title: "Erreur", text: "Export échoué" });
    }
}

export function* downloadEntitiesTemplateSaga() {
    const token = sessionStorage.getItem("token");
    try {
        const res = yield call(getBlobRequest, {
            url: `${API_BASE_URL}/api/entities/template`,
            token: `Bearer ${token}`,
        });
        downloadBlob(new Blob([res.data]), "template_entites.xlsx");
        yield put({ type: DOWNLOAD_ENTITIES_TEMPLATE_SUCCESS });
    } catch (e) {
        yield put({ type: DOWNLOAD_ENTITIES_TEMPLATE_FAIL });
        Swal.fire({ icon: "error", title: "Erreur", text: "Téléchargement template échoué" });
    }
}

// Dans le watcher :

export function* getOrgSaga() {
    const url = `${API_BASE_URL}/api/entities/organigramme`;
    yield put(setEntiteLoading(true)); // ou setLoading global si tu as

    try {
        console.group("🔵 GET_ORG_REQUEST");
        console.log("⏱️ Heure:", new Date().toLocaleTimeString("fr-FR"));
        console.log("🌐 URL:", url);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group("✅ GET_ORG_SUCCESS");
        console.log("📥 Root entities:", resp.data?.length || 0);
        console.groupEnd();

        yield put(getOrganigrammeSuccess(resp.data || []));
        yield put(setEntiteLoading(false));
    } catch (error) {
        console.group("❌ GET_ORG_FAIL");
        console.error("🚨 Erreur:", error.message);
        console.groupEnd();

        yield put(getOrganigrammeFail(error.message));
        yield put(setEntiteLoading(false));
    }
}

export function* getEntiteSaga(action) {
    const url = `${API_BASE_URL}/api/entities/${action.payload.entiteId}`;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 GET_ENTITE_REQUEST');
        console.log('📊 Entite ID:', action.payload.entiteId);
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_ENTITE_SUCCESS');
        console.log('📥 Réponse API:', resp.data);
        console.groupEnd();

        yield put(getEntiteSuccess(resp.data));
        yield put(setEntiteLoading(false));

    } catch (error) {
        console.group('❌ GET_ENTITE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getEntiteFail(error.message));
        yield put(setEntiteLoading(false));
        // toast.error("Erreur lors de la récupération du entité");
    }
}

export function* getAllEntitesSaga(action) {
    const token = sessionStorage.getItem('token');

    const url = `${API_BASE_URL}/api/entities`;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 GET_ALL_ENTITES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url,token });

        console.group('✅ GET_ALL_ENTITES_SUCCESS');
        console.log('📥 Nombre de entités:', resp.data.length);
        console.groupEnd();

        yield put(getAllEntitesSuccess(resp.data));
        yield put(setEntiteLoading(false));

    } catch (error) {
        console.group('❌ GET_ALL_ENTITES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getAllEntitesFail(error.message));
        yield put(setEntiteLoading(false));
        // toast.error("Erreur lors de la récupération des entités");
    }
}

export function* getActiveEntitesSaga(action) {
    const url = `${API_BASE_URL}/api/entities/active`;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 GET_ACTIVE_ENTITES_REQUEST');
        console.log('⏱️ Heure:', new Date().toLocaleTimeString('fr-FR'));
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_ACTIVE_ENTITES_SUCCESS');
        console.log('📥 Nombre de entités actifs:', resp.data.length);
        console.groupEnd();

        yield put(getActiveEntitesSuccess(resp.data));
        yield put(setEntiteLoading(false));

    } catch (error) {
        console.group('❌ GET_ACTIVE_ENTITES_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getActiveEntitesFail(error.message));
        yield put(setEntiteLoading(false));
        // toast.error("Erreur lors de la récupération des entités actifs");
    }
}

export function* getEntitesByCategorySaga(action) {
    const url = `${API_BASE_URL}/api/entities/category/${action.payload.category}`;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 GET_ENTITES_BY_CATEGORY_REQUEST');
        console.log('📊 Catégorie:', action.payload.category);
        console.groupEnd();

        const resp = yield call(getRequest, { url });

        console.group('✅ GET_ENTITES_BY_CATEGORY_SUCCESS');
        console.log('📥 Nombre de entités:', resp.data.length);
        console.groupEnd();

        yield put(getEntitesByCategorySuccess(resp.data));
        yield put(setEntiteLoading(false));

    } catch (error) {
        console.group('❌ GET_ENTITES_BY_CATEGORY_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(getEntitesByCategoryFail(error.message));
        yield put(setEntiteLoading(false));
        // toast.error("Erreur lors de la récupération");
    }
}

export function* createEntiteSaga(action) {
    const url = `${API_BASE_URL}/api/entities`;
    const data = action.payload;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 CREATE_ENTITE_REQUEST');
        console.log('📊 Données:', data);
        console.groupEnd();

        const resp = yield call(postRequest, { url, data });

        console.group('✅ CREATE_ENTITE_SUCCESS');
        console.log('📥 Entité créé:', resp.data);
        console.groupEnd();

        yield put(createEntiteSuccess(resp.data));
        yield put(setEntiteLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Entité créé avec succès",
            timer: 2000,
            showConfirmButton: false
        });

        // Redirection optionnelle
        if (action.history) {
            yield put(push('/entities'));
        }

    } catch (error) {
        console.group('❌ CREATE_ENTITE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(createEntiteFail(error.message));
        yield put(setEntiteLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la création",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* updateEntiteSaga(action) {
    const url = `${API_BASE_URL}/api/entities/${action.payload.entiteId}`;
    const data = action.payload.entiteData;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 UPDATE_ENTITE_REQUEST');
        console.log('📊 Entite ID:', action.payload.entiteId);
        console.log('📊 Nouvelles données:', data);
        console.groupEnd();

        const resp = yield call(putRequest, { url, data });

        console.group('✅ UPDATE_ENTITE_SUCCESS');
        console.log('📥 Entité mise à jour:', resp.data);
        console.groupEnd();

        yield put(updateEntiteSuccess(resp.data));
        yield put(setEntiteLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: "Entité mise à jour avec succès",
            timer: 2000,
            showConfirmButton: false
        });

    } catch (error) {
        console.group('❌ UPDATE_ENTITE_FAIL');
        console.error('🚨 Erreur:', error.message);
        console.groupEnd();

        yield put(updateEntiteFail(error.message));
        yield put(setEntiteLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: "Erreur lors de la mise à jour",
            timer: 2000,
            showConfirmButton: false
        });
    }
}

export function* deleteEntiteSaga(action) {
    const url = `${API_BASE_URL}/api/entities/${action.entiteId}`;
    yield put(setEntiteLoading(true));

    try {
        console.group('🔵 DELETE_ENTITE_REQUEST');
        console.log('📊 Entite ID:', action.entiteId);
        console.groupEnd();

        yield call(deleteRequest, { url });

        console.group('✅ DELETE_ENTITE_SUCCESS');
        console.log('🗑️ Entité supprimée');
        console.groupEnd();

        yield put(deleteEntiteSuccess(action.entiteId));
        yield put(getAllEntitesRequest());

        yield put(setEntiteLoading(false));

        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: "Entité supprimée avec succès",
            timer: 2000,
            showConfirmButton: false
        });



    } catch (error) {
        console.group('❌ DELETE_ENTITE_FAIL');
        console.error('🚨 Erreur complète:', error);
        console.error('🚨 Response data:', error.response?.data);
        console.error('🚨 Response status:', error.response?.status);
        console.groupEnd();

        yield put(setEntiteLoading(false));

        // Extraire le message d'erreur
        let errorMessage = "Erreur lors de la suppression";

        if (error.response?.data?.message) {
            errorMessage = error.response.data.message;
        } else if (error.response?.data?.error) {
            errorMessage = error.response.data.error;
        } else if (error.message) {
            errorMessage = error.message;
        }

        yield put(deleteEntiteFail(errorMessage));

        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Erreur de suppression',
            text: errorMessage,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33'
        });
    }
}
